
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EngagementPostMetricsForInsightCheck"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementPostMetricsForInsightCheck"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"back"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"likes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saves"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exited"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shares"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forward"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reaches"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextStory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"navigation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkClicks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interaction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stickerTaps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"insightUrls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newFollowers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"followerReach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonFollowerReach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profileActivity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"audienceRetention"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressionsFromHome"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressionsFromOther"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressionsFromProfile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressionsFromHashtag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressionsFromDiscovery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageViewDurationHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageViewDurationMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressionsClickThroughRate"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":702}};
    doc.loc.source = {"body":"query EngagementPostMetricsForInsightCheck($postId: Int!) {\n  engagementPostMetricsForInsightCheck(postId: $postId) {\n    id\n    back\n    views\n    likes\n    saves\n    status\n    exited\n    shares\n    forward\n    reaches\n    socialMedia\n    comments\n    nextStory\n    navigation\n    linkClicks\n    interaction\n    stickerTaps\n    postContent\n    insightUrls\n    impressions\n    newFollowers\n    followerReach\n    nonFollowerReach\n    profileActivity\n    audienceRetention\n    impressionsFromHome\n    impressionsFromOther\n    impressionsFromProfile\n    impressionsFromHashtag\n    impressionsFromDiscovery\n    averageViewDurationHours\n    averageViewDurationMinutes\n    impressionsClickThroughRate\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EngagementPostMetricsForInsightCheck"] = oneQuery(doc, "EngagementPostMetricsForInsightCheck");
        
